<template>
  <div class="dataTypes">
    <div class="dataTypes-header">
      <div class="dataTypes-headerText">
        Datatypes
      </div>
      <div class="dataTypes-buttonHolder">
        <button-com
          iconName="list-add"
          text="Add New Datatype"
          @click.native="addDataType"
        ></button-com>
      </div>
    </div>
    <div class="dataTypes-dataType" v-for="(dataType, index) in dataTypes">
      <div class="dataTypes-inputButtonHolder">
        <div class="dataTypes-selectedDataType noUserSelect">
          <select :value="dataType.type" @input="updateType(index, $event)">
            <option v-for="existingDataType in existingDataTypes" :value="existingDataType.value">
              {{ existingDataType.text }}
            </option>
          </select>
        </div>
        <button-com
          iconName="delete"
          class="bm-ghost bm-onlyIcon"
          tooltip="Delete"
          @click.native="deleteDataType(index)"
        ></button-com>
      </div>
      <div class="dataTypes-number">
        <icon-com
          :text="index + 1"
          size="iconSize"
        ></icon-com>
      </div>
      <input class="dataTypes-input" type="text" placeholder="..." :value="dataType.name" @input="updateText(index, $event)">
    </div>
    <div class="dataTypes-empty" v-if="dataTypes.length === 0">
      No datatypes has been added
    </div>
  </div>
</template>

<script>
export default {
  props: ['currentDataTypes'],
  computed: {
    feeds () {
      return this.$store.state.feeds
    }
  },
  data () {
    return {
      dataTypes: [],
      existingDataTypes: [
        { text: 'Text', value: 'text' },
        { text: 'Nummer', value: 'number' },
        { text: 'Lista', value: 'list' },
        { text: 'Bild', value: 'image' },
        { text: 'Html', value: 'html' }
      ]
    }
  },
  watch: {
    dataTypes: function () {
      this.$emit('dataTypes', this.dataTypes)
    }
  },
  mounted () {
    this.dataTypes = this.currentDataTypes || []
  },
  methods: {
    updateText (index, e) {
      this.$store.commit({
        type: 'updateDataType',
        property: 'name',
        value: e.target.value,
        index
      })
    },
    updateType (index, e) {
      this.$store.commit({
        type: 'updateDataType',
        property: 'type',
        value: e.target.value,
        index
      })
    },
    addDataType () {
      this.$store.commit('addDataType')
    },
    deleteDataType (index) {
      this.$store.commit('deleteDataType', index)
    }
  }
}
</script>

<style lang="sass">
@import './../sass/core.sass'

+block('dataTypes')
  width: 100%

  +element('header')
    height: 40px
    margin-bottom: 25px
    line-height: 40px
    display: flex
    position: relative
    width: 100%

  +element('input')
    padding-left: 40px

  +element('headerText')
    padding-left: 25px

  +element('buttonHolder')
    position: absolute
    right: 0

  +element('selectedDataType')
    height: 40px
    min-width: 40px
    justify-content: center
    display: flex
    align-items: center

  +element('number')
    position: absolute
    left: 10px
    top: 10px

  +element('inputButtonHolder')
    position: absolute
    display: flex
    height: 40px
    right: 5px
    top: 5px

  +element('name')
    padding-left: 25px
    text-transform: capitalize
    font-size: 12px

  +element('dataType')
    margin-bottom: 10px
    position: relative

  +element('empty')
    text-align: center
    height: 50px
    border-radius: 50px
    border: 2px dashed $divider
    line-height: 48px
    box-sizing: border-box
    margin-bottom: 10px

</style>



// WEBPACK FOOTER //
// src/components/DataTypes.vue